import { t } from '@lingui/core/macro';
import { BookingProposalType } from '@navio/nsdk';

/** Customer-facing name for a proposal type — the backend labels read as internal jargon. */
export const getProposalTypeLabel = (type: BookingProposalType): string => {
  switch (type) {
    case BookingProposalType.RECALL_PROPOSAL_TIRE_HOTEL:
      return t`Tire hotel`;
    case BookingProposalType.RECALL_PROPOSAL_WHEEL_CHANGE:
      return t`Wheel change`;
    case BookingProposalType.TIRE_CHANGE_AT_CUSTOMER:
      return t`Tire change at home`;
    case BookingProposalType.TIRE_CHANGE_AT_STORAGE_FACILITY:
      return t`Tire change at service center`;
  }
};
